import type { ComputedRef } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): ComputedRef<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      personal: {
        list_personal: {
          create_admin: {
            main_title: 'MAIN_TITLE',
            name: 'NAME',
            email: 'EMAIL',
            role: 'ROLE',
            create: 'CREATE',
            back: 'BACK',
          },
        },
      },
    },
  }));
}
